export default function(text: string, maxLength: number = 20) {
  if (text.length <= maxLength) {
    return text
  }
  const ellipsis = '...'
  if (maxLength <= ellipsis.length) {
    return ellipsis
  }
  const truncatedText = text.slice(0, maxLength - ellipsis.length)
  return truncatedText + ellipsis
}
